import { Link } from 'react-router-dom'
import '../assets/css/SerialCard.css'
import { getImageUrl } from '../services/CommonService'
import { memo } from 'react'

const SerialCard = memo(function SerialCard({ serialId, title, image, url, articleCount }) {
    return (
        <Link to={"/serijali/" + url} state={{ serialId, title, image }} className="serial-card">
            <div className="serial-card-image-div">
                <img src={getImageUrl(image.imageName)} className="serial-card-img" alt={image.altText} />
                <div className="serial-card-overlay">
                    <p className="serial-card-title">{title}</p>
                </div>
                {articleCount != null && (
                    <span className="serial-card-badge">{articleCount} članaka</span>
                )}
            </div>
        </Link>
    )
})

export default SerialCard